import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './components/App/index';
// to get tailwind
import './assets/css/style.css';
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
